import { MicroFrontendRouteSlot, mfeCacheKey } from "@shared/components";
import { IDP_DASHBOARD_REMOTE } from "@shared/federation/remoteApps";

export function IdpDashboardPage() {
  return (
    <MicroFrontendRouteSlot
      cacheKey={mfeCacheKey(IDP_DASHBOARD_REMOTE.id)}
      route={IDP_DASHBOARD_REMOTE}
    />
  );
}
